import { render, staticRenderFns } from "./ListTagEllipsis.vue?vue&type=template&id=2c8dcb47"
import script from "./ListTagEllipsis.vue?vue&type=script&lang=js"
export * from "./ListTagEllipsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports